import { render, staticRenderFns } from "./ResultsGallery.vue?vue&type=template&id=ea5bc902&"
import script from "./ResultsGallery.vue?vue&type=script&lang=js&"
export * from "./ResultsGallery.vue?vue&type=script&lang=js&"
import style0 from "./ResultsGallery.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports